import request from '../../../shared/request'

export function getJobSiteDriverRequests(job_id) {
  return request(`/job/job_site_driver_requests/${job_id}/`)
}

export function createJobSiteDriverRequest(payload) {
  return request(`/job/job_site_driver_requests/${payload.job_id}/`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function driverRequestReport(driver_request_id) {
  return request(`/job/job_site_driver_requests/print/${driver_request_id}/`)
}

export function updateJobSiteDriverRequest(payload) {
  return request(`/job/job_site_driver_requests/${payload.driver_request_id}/`, {
    method: 'PUT',
    body: payload.data,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteJobSiteDriverRequest(payload) {
  return request(`/job/job_site_driver_requests/${payload.driver_request_id}/`, {
    method: 'DELETE',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function uploadAttachments(payload) {
  return request(`/job/job_site_driver_requests/${payload.driverRequestId}/attachment`, {
    method: 'POST',
    body: payload.formData,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function getAttachments(driverRequestId) {
  return request(`/job/job_site_driver_requests/${driverRequestId}/attachments/`)
}

export function updateAttachmentDescription(payload) {
  return request(`/job/job_site_driver_requests/${payload.attachmentId}/attachment`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteAttachment(payload) {
  return request(`/job/job_site_driver_requests/${payload.attachmentId}/attachment/`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/job/jobSiteDriverRequests.js